const LICENSE_PLATE_PATTERN = /^[A-Z0-9]+$|^$/

export const validLicensePlate = value => LICENSE_PLATE_PATTERN.test(value)
